var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOmnichain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: "24px",
    height: "24px",
    viewBox: "0 0 32 32",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "social icon for OmniChain") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1C347A",
    fillRule: "evenodd",
    d: "M27.3 27.3A16 16 0 1 0 4.69 4.67a16 16 0 0 0 22.63 22.65ZM24.32 7.7a11.78 11.78 0 0 1 2.52 12.82 11.79 11.79 0 0 1-10.95 7.23 11.76 11.76 0 0 1 .15-23.51c3.11.01 6.09 1.26 8.28 3.46Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C347A",
    d: "M30.67 1.3a518 518 0 0 0-5.32.02 18.26 18.26 0 0 1 5.32 5.32V1.3ZM30.67 30.72v-5.37a18.18 18.18 0 0 1-5.32 5.37h5.32ZM1.3 6.62a18.05 18.05 0 0 1 5.35-5.3c-.38-.04-5.24-.02-5.35.01v5.3ZM1.33 30.7h5.3a18.14 18.14 0 0 1-5.3-5.35c-.04.22-.03 5.22 0 5.34Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOmnichain);
export default __webpack_public_path__ + "static/media/omnichain.a6e609cfb14da8f8e71ec54560fff6fb.svg";
export { ForwardRef as ReactComponent };